import prodClient from 'client/prod';
import messages from 'messages/en.ton.json';

prodClient(messages);
